import React, { Component } from 'react';
import { connect } from 'react-redux';
import Home from "../desktop/Home";
import {dispatchUnreadPopup} from "../../helpers/popupHelper";

/**
 * Import assets
 */

class Desktop extends Component {
  static propTypes = {
  };
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillUnmount() {
    document.body.classList.remove('desktop-map');
  }

  componentDidMount() {
    const { gameState, dispatch, project } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if(currentRound === 1 && gameState.currentStep === 1){
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhgvtlandbesturen1_T1' : 'dlgvtlandbesturen1_T1'), dispatch, false, true);
    }
    if(currentRound === 2 && gameState.currentStep === 1){
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhgvtlandbesturen2_T1' : 'dlgvtlandbesturen2_T1'), dispatch, true, true);
    }
    if(currentRound === 1 && gameState.currentStep === 3){
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhgvtbudgetverdelen_T1' : 'dlgvtbudgetverdelen_T1'), dispatch, false, true);
    }
    if(currentRound === 1 && gameState.currentStep === 2){
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhgvtbelastingheffen_T1' : 'dlgvtbelastingheffen1_T1'), dispatch, false, true);
    }
    if(currentRound === 2 && gameState.currentStep === 2){
      if(project.difficulty === "BASIC") {
        dispatchUnreadPopup('dlgvtbelastingheffen2_T1', dispatch);
      }
    }

    document.body.classList.add('desktop-map');
  }

  render() {
    return (
      <div>
        <Home
          history={this.props.history}
          currentMin={this.props.match.params.id}/>
      </div>
    );
  }
}

export default connect(state => state)(Desktop);



// WEBPACK FOOTER //
// ./src/components/routes/Desktop.js